import envs from "@/envs.ts";
import PATHS from "@/routes/paths.ts";

export default function LogOut() {
  window.location.replace(
    `${envs.VITE_API_URL}/authentication/logout?redirect_url=${envs.VITE_SITE_URL}${PATHS.SIGN_IN}`,
  );

  return null;
}
